// Contact form
// HTML:  	https://vrendle.test/res/contact.html
import { ServerRequest } from '@nutshell/core';
import $ from 'jquery';

const form = document.querySelector('#form-contact');
const formConfirmation = document.querySelector('.c-form-confirmation');

if ( form ) {

	const button = form.querySelector('button[type=submit]');

    form.addEventListener('valid', (event) => {

        event.preventDefault();

        /**
         * Submit form when is validated by Abide.
         * Form needs an attribute `data-form-validate` to trigger the `valid` event.
         * If the form doesn't use the core validator, use the event `submit`
         */
        const rqst = new ServerRequest();
        button.disabled = true;

        rqst.submit('#form-contact', 'submitContact').then( ( { result } ) => {

        	button.disabled = false;
           	
            // new confirmation
            $(form).fadeOut();
            $(formConfirmation).fadeIn();

            $('html, body').animate({
                scrollTop: $(form).offset().top-50
            }, 500);

        }).catch( () => {
            console.log('Something went wrong');
        });
    });
}